var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4641",
    "data-name": "Raggruppa 4641",
    transform: "translate(-278 -258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4638",
    "data-name": "Raggruppa 4638",
    transform: "translate(104 68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4632",
    "data-name": "Raggruppa 4632",
    transform: "translate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4627",
    "data-name": "Raggruppa 4627",
    transform: "translate(72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2111",
    "data-name": "Rettangolo 2111",
    width: 24,
    height: 24,
    transform: "translate(60 190)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-call",
    "data-name": "Icon ionic-ios-call",
    d: "M20.994,17.809a14.275,14.275,0,0,0-2.982-2c-.894-.429-1.221-.42-1.854.035-.526.38-.867.734-1.473.6a8.789,8.789,0,0,1-2.96-2.19,8.725,8.725,0,0,1-2.19-2.96c-.128-.611.226-.947.6-1.473.456-.633.469-.96.035-1.854a13.992,13.992,0,0,0-2-2.982c-.65-.65-.8-.509-1.155-.38a6.571,6.571,0,0,0-1.057.562A3.19,3.19,0,0,0,4.7,6.514c-.252.544-.544,1.557.942,4.2a23.452,23.452,0,0,0,4.123,5.5h0l0,0,0,0h0a23.544,23.544,0,0,0,5.5,4.123c2.646,1.487,3.659,1.195,4.2.942a3.135,3.135,0,0,0,1.341-1.27,6.571,6.571,0,0,0,.562-1.057C21.5,18.605,21.649,18.459,20.994,17.809Z",
    transform: "translate(277.51 256.498)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.956ac1e75ffe67924a6ba5b53b17fd42.svg";
export { ForwardRef as ReactComponent };